// eslint-disable-next-line import/no-anonymous-default-export
export default {
  company: {
    introduce: {
      community: {
        title: "社区版用户管理",
        description: "社区版用户管理主要用于管理并查看所有云扩社区版用户信息.",
      },
      enterprise: {
        title: "企业版用户管理",

        description:
          "企业版用户管理主要用于管理并创建各个企业级用户，支持对单个用户部分系统配置进行管理。",
      },
    },
    companyId: "公司ID",
    companyName: "公司名称",
    companyType: "公司类型",
    companyInfo: "公司信息",
    companySize: "公司规模",
    companyEmail: "公司邮箱",
    AccountSetting: "账户设置",
    isFixedPostfixMailbox: "是否限制用户内账户为固定后缀邮箱",
    mailboxPostfixConfiguration: "邮箱后缀配置",
    addSuffix: "添加后缀",
    addSuffixTip: "点击添加按钮添加后缀",
    initializeAdministratorAccount: "初始管理员账号",
    initializeAdministratorPassword: "初始管理员密码",
    updatePasswordTips: "若保持该项为空提交则意味着不对该项做任何更改",
    licenseDetail: "许可证详情",
    licenseNumber: "所属许可证编号",
    renewContract: "续约",
    renewContractSuccessfully: "续约成功",
    setting: {
      name: "基本信息",
      title: "用户基本信息",
      customerIdentifier: "公司ID（标识码）",
    },
    validate: {
      stringLength: "{name}须在{min}-{max}字符之间",
      inputCompanyName: "请输入公司名称",
      inputPrefix: "请输入邮箱前缀",
      inputSuffix: "请输入邮箱后缀",
      prefixErr: "邮箱前缀格式错误",
      suffixErr: "邮箱后缀格式错误",
      selectSuffix: "请选择邮箱后缀",
      emailSuffixRepeat: "邮箱后缀重复",
      addEmailSuffix: "请添加邮箱后缀",
      inputPassword: "请输入密码",
      inputCompanyType: "请输入公司类型",
    },
  },
};
